import {getRouteApi} from "@tanstack/react-router";

export const supplierFunctionsRouteApi = getRouteApi("/_app/engineering/suppliers/functions/");
